import React from 'react';

// The content area of a screen: same padding everywhere and one of two
// widths (assets/style/page.scss):
//   width='wide'   lists, dashboards — fills the window up to 1600px (default)
//   width='narrow' detail and form pages — up to 1280px
// `stack` lays the children out as a column of cards with even spacing.
export default function PageContainer({
  width = 'wide', stack, className, children,
}) {
  const classes = ['page-container', `page-${width}`, stack ? 'page-stack' : '', className || '']
    .filter(Boolean).join(' ');
  return <main className={classes}>{children}</main>;
}
